import React, { useEffect, useState } from 'react';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { getData } from '../../../functions/getData';
import { CircularProgress } from '@material-ui/core'

function CloseInfo(props) {
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const userCloseId = props.cardsGroup.attributes.closing_user_id;

    const getUserData = async (idUser) => {
        const URL = {
            method: 'GET',
            value: `/web-api/users/${idUser}`
        };
        try {
            setIsLoading(true)
            const data = await getData(URL);
            return data;
        } catch (error) {
            console.error("Error fetching user data:", error);
            return null;
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        if (userCloseId) {
            getUserData(userCloseId).then(data => {
                if(data) {
                    if (Object.keys(data).length > 0) {
                        setUserData(data);
                    }
                }
            });
        }
    }, [userCloseId]); 

    if (isLoading) {
        return (
            <div className='info-container mw-100'>
                <CircularProgress style={{ width:'20px', height:'20px' }} />
            </div>
        );
    }

    if (!userData) {
        return <div></div>;
    }

    const firstName = userData.attributes.first_name;
    const lastName = userData.attributes.last_name;
    const position = userData.attributes.position;
    const avatarSrc = `https://ui-avatars.com/api/?name=${firstName} ${lastName}&size=128`;
    return (
        <div className='info-container'>
            <p className='card-text'>{'Cerrado por'}</p>
                {userCloseId && (
                    <div className='m-2 small' key={userCloseId}>
                        <Chip avatar={<Avatar src={avatarSrc} />} label={`${firstName} ${lastName} ${position? '- ' + position : ''}`} />
                    </div>
                )}
        </div>
    );
}

export default CloseInfo;
